const getters = {
  userInfo: state => state.user.userInfo,//头部导航面包屑
  api: state => state.api.api,//后台接口
  windowSize: state => state.user.windowSize,//窗口大小
  orgInfo: state => state.user.orgInfo,//公司信息
  isChangePassword: state => state.user.isChangePassword,//密码规则
  desensitizationName: state => state.app.desensitizationName,//姓名脱敏
  desensitizationPhone: state => state.app.desensitizationPhone,//手机号脱敏
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js